module.exports = __webpack_public_path__ + "static/img/competitiveness_04@3x.be57e18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/competitiveness_04@3x.png
// module id = SM7R
// module chunks = 1